import { DataConverter } from "../../Global/Base/Converters/DataConverter";
import { ISigningAppCommunicator, IWritableStream } from "./CryptoInterfaces";
import { CommandType } from "./Messages/CommandType";
import { IStreamData } from "./Messages/MessagesInterface";
import { TransferEncoding } from "./Messages/TransferEncoding";

export class WritableStream implements IWritableStream {
    private readonly _streamId: string;
    private readonly _communicator: ISigningAppCommunicator;

    /**
     * Název reprezentující data
     */
    public name: string;

    /**
     * Unikátní identifikátor streamu dat
     */
    public get streamId(): string {
        return this._streamId;
    }

    constructor(streamId: string, communicator: ISigningAppCommunicator) {
        this._streamId = streamId;
        this._communicator = communicator;
    }

    /**
     * Zapíše do streamu (a pošle do doplňku) kus dat
     * @param data zapisovaná data v textové nebo binární podobě
     * @param isLastBlock zda je zapisovaný blok poslední
     */
    public async writeBlock(data: string | ArrayBuffer, isLastBlock: boolean): Promise<void> {
        let stringData: string;
        let encoding: TransferEncoding;
        let dataLength: number;

        if (typeof data === "string") {
            stringData = data;
            encoding = TransferEncoding.Text;
            dataLength = data.length;
        } else {
            stringData = DataConverter.bufferToBase64(data);
            encoding = TransferEncoding.Base64;
            dataLength = data.byteLength;
        }

        const dataMessage: IStreamData = {
            streamId: this.streamId,
            encoding: TransferEncoding[encoding],
            isEnd: isLastBlock,
            length: dataLength,
            data: stringData,
        };

        await this._communicator.postMessage(CommandType.SendStreamBlock, dataMessage);
    }
}
